<template>
  <div class="form-input">
    <input
      type="email"
      :placeholder="placeholder"
      autocomplete="off"
      pattern="[A-Za-z0-9._%+-]{3,}@[A-Za-z0-9]{2,}([.]{1}[A-Za-z0-9]{2,}|[.]{1}[A-Za-z0-9]{2,}[.]{1}[A-Za-z0-9]{2,})"
      @keyup="changed"
      v-model.trim="val"
    />
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      val: this.value
    };
  },
  watch: {
    value: function(val) {
      this.val = val;
    }
  },
  methods: {
    changed: function(e) {
      if (!e.target.validity.valid) return;

      this.$emit("input", e.target.value);

      return;
    }
  }
};
</script>